
import { createSlice } from "@reduxjs/toolkit";
import { IFabrixIcons } from "../types";
import { createUUID } from "../common";

export interface SocketDataItem {
    id: string;
}


export interface SocketDataState {
    [key: string]: SocketDataItem[];
}


export const initSocketState: SocketDataState = {

}

const SocketDataSlice = createSlice({
    name: 'socket',
    initialState: initSocketState,
    reducers: {
        setSocketData(state, action) {
            let eventName = action.payload.eventName;
            let eventData = state[eventName]
            let data: any[];
            if (!eventData || !Array.isArray(eventData))
                data = new Array<any>();
            else
                data = [...eventData]
            if (Array.isArray(action.payload.data)) {
                action.payload.data.forEach((x: SocketDataItem) => {
                    if (!x.id)
                        x.id = createUUID()
                    let index = data.findIndex(y => y.id === x.id)
                    if (index === -1) {
                        data.push(x)
                    } else {
                        data[index] = x;
                    }

                })
            } else {
                let item = action.payload.data;
                if (!item.id)
                    item.id = createUUID()
                let index = data.findIndex(y => y.id === item.id)
                if (index === -1) {
                    data.push(item)
                } else {
                    data[index] = item;
                }
            }
            state[eventName] = data.sort((a, b) => a.index - b.index);
        },
        clearSocketData(state, action) {
            let eventName = action.payload.eventName;
            let ids = action.payload.items as string[] ?? [];
            let eventData = state[eventName]
            if (eventData) {
                if (ids?.length > 0)
                    state[eventName] = eventData.filter(x => !ids.includes(x.id))
                else
                    state[eventName] = [];

            }
        }

    },
    extraReducers: (builder) => {
    }
});

export const { setSocketData, clearSocketData } = SocketDataSlice.actions;
export default SocketDataSlice.reducer;